module.exports = pratt.PrattSharedLibs.instantsearch.connectors;